import {
    Heading1, Heading2, Heading3, List, ListOrdered,
    CheckSquare, Quote, Minus, Code,
    Image as ImageIcon, ChevronRight, Table as TableIcon, 
    Info, AlertTriangle, Lightbulb, ShieldAlert,
    Columns as ColumnsIcon
} from 'lucide-react';

export const TEXT_COLORS = [
    { label: 'Default', value: null },
    { label: 'Red', value: '#EF4444' },
    { label: 'Orange', value: '#F97316' },
    { label: 'Yellow', value: '#EAB308' },
    { label: 'Green', value: '#22C55E' },
    { label: 'Blue', value: '#3B82F6' },
    { label: 'Purple', value: '#8B5CF6' },
    { label: 'Pink', value: '#EC4899' },
    { label: 'Gray', value: '#6B7280' },
];

export const HIGHLIGHT_COLORS = [
    { label: 'Default', value: null },
    { label: 'Yellow', value: '#FEF08A' },
    { label: 'Green', value: '#BBF7D0' },
    { label: 'Blue', value: '#BFDBFE' },
    { label: 'Purple', value: '#E9D5FF' },
    { label: 'Pink', value: '#FBCFE8' },
    { label: 'Orange', value: '#FED7AA' },
    { label: 'Red', value: '#FECACA' },
];

export const SLASH_CATEGORIES = [
    {
        label: '📝 Basic Blocks',
        items: [
            { label: 'Heading 1', desc: 'Large heading', icon: Heading1, command: (e) => e.chain().focus().toggleHeading({ level: 1 }).run() },
            { label: 'Heading 2', desc: 'Medium heading', icon: Heading2, command: (e) => e.chain().focus().toggleHeading({ level: 2 }).run() },
            { label: 'Heading 3', desc: 'Small heading', icon: Heading3, command: (e) => e.chain().focus().toggleHeading({ level: 3 }).run() },
        ],
    },
    {
        label: '📋 Lists',
        items: [
            { label: 'Bullet List', desc: 'Simple bullets', icon: List, command: (e) => e.chain().focus().toggleBulletList().run() },
            { label: 'Numbered List', desc: 'Ordered items', icon: ListOrdered, command: (e) => e.chain().focus().toggleOrderedList().run() },
            { label: 'Task List', desc: 'Checkboxes', icon: CheckSquare, command: (e) => e.chain().focus().toggleTaskList().run() },
        ],
    },
    {
        label: '🎨 Rich Blocks',
        items: [
            { label: 'Quote', desc: 'Block quotation', icon: Quote, command: (e) => e.chain().focus().toggleBlockquote().run() },
            { label: 'Divider', desc: 'Horizontal line', icon: Minus, command: (e) => e.chain().focus().setHorizontalRule().run() },
            { label: 'Toggle', desc: 'Collapsible block', icon: ChevronRight, command: (e) => e.chain().focus().setDetails().run() },
            { label: 'Table', desc: '3×3 with header', icon: TableIcon, command: (e) => e.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run() },
            { label: 'Image', desc: 'Insert an image', icon: ImageIcon, command: (e, helpers) => helpers?.promptImage?.() },
        ],
    },
    {
        label: '📢 Callouts',
        items: [
            { label: 'Info', desc: 'Blue info box', icon: Info, command: (e) => e.chain().focus().setCallout({ type: 'info' }).run() },
            { label: 'Warning', desc: 'Orange warning', icon: AlertTriangle, command: (e) => e.chain().focus().setCallout({ type: 'warning' }).run() },
            { label: 'Tip', desc: 'Green tip box', icon: Lightbulb, command: (e) => e.chain().focus().setCallout({ type: 'tip' }).run() },
            { label: 'Danger', desc: 'Red danger alert', icon: ShieldAlert, command: (e) => e.chain().focus().setCallout({ type: 'danger' }).run() },
        ],
    },
    {
        label: '💻 Code',
        items: [
            { label: 'Code Block', desc: 'Syntax-highlighted', icon: Code, command: (e) => e.chain().focus().toggleCodeBlock().run() },
        ],
    },
    {
        label: '🗂️ Layouts',
        items: [
            { label: '2 Columns', desc: 'Side-by-side', icon: ColumnsIcon, command: (e) => e.chain().focus().setColumns(2).run() },
            { label: '3 Columns', desc: 'Three equally spaced', icon: ColumnsIcon, command: (e) => e.chain().focus().setColumns(3).run() },
        ],
    },
];

export const ALL_SLASH_ITEMS = SLASH_CATEGORIES.flatMap(cat =>
    cat.items.map(item => ({ ...item, category: cat.label }))
);
